import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import _, { cloneDeep as _cloneDeep } from 'lodash';
import {
  getArchivedCampaignsAndEditions,
  getArchivedEditions,
  restoreCampaignR,
  deleteArchivedCampaignR,
} from 'actions/ArchiveActions';
import SimplePrompt from '../SimplePrompt';
import Loader from '../Loader';
import EditionPreviews from '../campaigns/EditionPreviews';
import may from '../../../security';
import { ROLE_ROOT_EMPLOYEE, S3_LINKS_DIV } from '../../../constants';
import { getPDFR, setVariables } from '../../../actions/CampaignActions';

class Archives extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previewing: false,
      cCampaigns: [],
      cEditions: [],
      storeC: [],
      openedCampaign: undefined,
    };
  }

  getFilterAsString = () => {
    const { urlData } = this.props;
    const filterString = Object.entries(urlData?.filters)
      .map(([key, values]) => {
        if(values !== undefined){
          const encodedKey = encodeURIComponent(key);
          const encodedValues = values.map(value => encodeURIComponent(value));
          return `filters%5B${encodedKey}%5D%5B%5D=${encodedValues.join(`&filters%5B${encodedKey}%5D%5B%5D=`)}`;
        }
          return '';
      })
      .join('&');
    return filterString;
  };

  componentDidMount = () => {
    this.props.getArchivedCampaignsAndEditions(this.getFilterAsString());
  };

  componentDidUpdate = prevProps => {
    if (prevProps.archivedCampaigns !== this.props.archivedCampaigns) {
      this.ShowCampaigns();
    }
    if (prevProps.archivedEditions !== this.props.archivedEditions) {
      this.ShowEditions();
    }

    if (this.props.pending !== prevProps.pending && this.props.pending === false) {
      this.ShowEditions();
    }
  };

  getPDF = (type, editionId) => {
    const {
      intl: { messages },
    } = this.props;
    // set previewing to editionID
    this.props.setVariables(editionId);
    this.setState({
      previewing: editionId,
    });
    let api = 'previewcopies';
    if (type === 'print') {
      api = 'mastercopies';
    } else if (type === 'image') {
      api = 'images/mastercopies';
    }
    const { getPDFR } = this.props;
    getPDFR(api, editionId, messages);
  };

  webPreview = () => {
    const { edition } = this.props;
    const preview = window.open(
      window.location.protocol + '//' + window.location.hostname + '/de/website/' + edition.id,
      '_blank'
    );
    preview.focus();
  };

  removeCampaign = (e, campaignId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteArchivedCampaignR(campaignId);
  };

  restoreCampaign = campaignId => {
    this.props.restoreCampaignR(campaignId, true);
  };

  ShowCampaigns = () => {
    const { archivedCampaigns, pendingRestoreC, pendingDeleteC, intl: { messages }, } = this.props;
    let campaignsss;
    if (archivedCampaigns) {
      campaignsss = archivedCampaigns.map(dCampaigns => {
        if (1 === 1 /* dCampaigns.is_active === false */) {
          return (
            <div className="archivedCampaigns" key={dCampaigns.id}>
              {pendingRestoreC || pendingDeleteC ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <div
                className="aCContent"
                /* currently not in use
                onClick={() => {
                  this.openCampaign(dCampaigns.id);
                }}
                 */
              >
                <h5>{dCampaigns.title}</h5>
                {may(ROLE_ROOT_EMPLOYEE, this.props.user.roles) && dCampaigns.creator !== null ? (
                  <p>
                    {dCampaigns.creator.profile.first_name +
                      ' ' +
                      dCampaigns.creator.profile.last_name +
                      ' ' +
                      dCampaigns.creator.profile.email}
                  </p>
                ) : (
                  <></>
                )}
              </div>
              <SimplePrompt
                disabled=""
                onSuccess={e => {
                  this.removeCampaign(e, dCampaigns.id);
                }}
              />
              <Button
                className="buttonRestore"
                style={{ margin: '0 auto', width: 'max-content' }}
                onClick={() => this.restoreCampaign(dCampaigns.id)}
              >
                <i className="far fa-trash-restore" />
                <span className="restoreText"> {messages.restore}</span>
              </Button>
            </div>
          );
        }
        return <></>;
      });
    }
    this.setState({ cCampaigns: campaignsss });
  };

  ShowEditions = option => {
    const { archivedEditions, parentIsMain2, pendingRestoreC, pendingDeleteC, previewingR, intl: { messages } } = this.props;
    const { openedCampaign } = this.state;
    let editionsss;
    const initialPreview = S3_LINKS_DIV.TEMPLATE_INITIAL_PREVIEW;
    let filter;
    let disablePreview = '';

    if (previewingR !== false) {
      disablePreview = 'disabled';
    }
    if (archivedEditions) {
      editionsss = archivedEditions.map(dEditions => {
        const lastEdit = new Date(dEditions.mdate);
        const created = new Date(dEditions.cdate);
        const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: 'numeric' };

        if (option === undefined || option === '' || option === 'store') {
          if (parentIsMain2 === true) {
            // root
            filter = true;
          } else {
            // unterverzeichnis
            filter = dEditions.campaign.id === openedCampaign;
          }
        } else {
          // back
          // filter = dEditions.where_in_trash === "main";
          console.log('back');
        }
        if (/* dEditions.is_active === true && */ filter) {
          return (
            <div className="edition" key={dEditions.id}>
              {pendingRestoreC || pendingDeleteC ? (
                <div className="TitleAndLoader">
                  <Loader />
                </div>
              ) : (
                <></>
              )}
              <header>
                <div className="header-left">
                  <Dropdown id={'settings-' + dEditions.id}>
                    <Dropdown.Toggle noCaret className="bg-red">
                      <i className="fas fa-bars" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {dEditions.template && dEditions.template.export_type.value === '000000000000000000000001' ? (
                        <MenuItem disabled={disablePreview} onClick={() => this.getPDF('image', dEditions.id)}>
                          {messages.campaign.export_image}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      ) : dEditions.template && dEditions.template.export_type.value === '000000000000000000000003' ? (
                        <MenuItem disabled={disablePreview} onClick={() => this.webPreview()}>
                          {messages.campaign.edition_preview}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      ) : (
                        <MenuItem disabled={disablePreview} onClick={() => this.getPDF('preview', dEditions.id)}>
                          {messages.campaign.edition_preview}{' '}
                          {previewingR === dEditions.id && <i className="fa fa-spin fa-spinner-third" />}
                        </MenuItem>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="header-fill">
                  <h4>{dEditions?.template?.title}</h4>
                </div>
              </header>

              <div className="details" style={{ borderBottom: 'unset' }}>
                <div className="details-content">
                  <div className="row">
                    <div className="col-md-7 p-l-0">
                      <p>
                        <span>{messages.campaign.edition_title + ':'}</span>
                        <span className="edition_title">{dEditions.title}</span>
                      </p>
                      <p>
                        <span>{messages.campaign.created_by}</span>
                        <span className="edition_title">
                          {dEditions.creator
                            ? dEditions.creator.profile.first_name + ' ' + dEditions.creator.profile.last_name
                            : messages.campaign.unknown}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-5 p-r-0 text-right">
                      <p>
                        <span>{messages.campaign.last_edited}</span>
                        <span className="w110">{lastEdit.toLocaleDateString('de-DE', options)}</span>
                      </p>
                      <p>
                        <span>{messages.campaign.generated}</span>
                        <span className="w110">{created.toLocaleDateString('de-DE', options)}</span>
                      </p>
                    </div>
                  </div>
                    <EditionPreviews
                      key={'previews_' + dEditions.id}
                      editionPreviews={dEditions.previews}
                      type={dEditions?.template?.export_type?.value}
                    />
                </div>
              </div>
            </div>
          );
        }
        return <></>;
      });
    }
    if (option === 'back') {
      this.setState({ cEditions: editionsss, openedCampaign: 'main' });
    } else {
      this.setState({ cEditions: editionsss });
    }
  };

  openCampaign = campaignId => {
    this.setState(prevState => {
      const index = _.findIndex(prevState.storeC, store => store === campaignId);

      if (index > -1) {
        this.ShowEditions('store');
      } else {
        const addCampaignsToStore = _cloneDeep(prevState.storeC);
        addCampaignsToStore.push(campaignId);
        this.setState({ storeC: addCampaignsToStore });
        const { getArchivedEditions } = this.props;
        getArchivedEditions(campaignId);
      }

      return { openedCampaign: campaignId };
    });
  };

  render() {
    const { archivedCampaigns, intl: { messages } } = this.props;
    const { cCampaigns, cEditions, openedCampaign } = this.state;

    let openedCampaignName = '';
    if (openedCampaign) {
      const index = _.findIndex(archivedCampaigns, campaign => campaign.id === openedCampaign);
      if (index > -1) {
        openedCampaignName = archivedCampaigns[index].title;
      }
    }
    return (
      <div style={{ paddingRight: '20px' }}>
        <h1>Archive</h1>

        <h3>{messages.archived_campaigns}</h3>
        {this.props.pendingRestoreC ? (
          <span>
            {messages.pls_wait}
            <Loader />
          </span>
        ) : (
          <></>
        )}
        {this.props.pendingDeleteC ? (
          <span>
            {messages.pls_wait}
            <Loader />
          </span>
        ) : (
          <></>
        )}
        {this.state.openedCampaign && this.state.openedCampaign !== 'main' ? (
          <Button
            style={{ display: 'block', margin: '20px 20px 20px 0', width: 'max-content' }}
            bsStyle="success"
            onClick={() => this.ShowEditions('back')}
          >
            <span className="restoreText">{messages.go_back}</span>
          </Button>
        ) : (
          <></>
        )}
        <div className="editions">
          {this.props.pending ? (
            <Loader />
          ) : this.state.openedCampaign === 'main' || this.state.openedCampaign === undefined ? (
            cCampaigns
          ) : (
            <></>
          )}
        </div>
        {/*
          <h3>
            {messages.archived_editions} {openedCampaignName ? <>in {openedCampaignName} </> : <></>}
          </h3>
          {this.props.pendingRestoreC ? (
            <span>
              {messages.pls_wait}
              <Loader />
            </span>
          ) : (
            <></>
          )}
          {this.props.pendingDeleteC ? (
            <span>
              {messages.pls_wait}
              <Loader />
            </span>
          ) : (
            <></>
          )}
          <div className="editions">{this.props.pending ? <Loader /> : cEditions}</div>
        */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.campaigns,
    user: state.login.user,
    client: state.selectedClient.company,
    archivedCampaigns: state.archive.archivedCampaigns,
    archivedEditions: state.archive.archivedEditions,
    pending: state.archive.pending,
    parentIsMain2: state.archive.parentIsMain2,
    pendingRestoreC: state.archive.pendingRestoreC,
    restore: state.archive.restore,
    errorMessage: state.archive.errorMessage,
    pendingDeleteC: state.archive.pendingDeleteC,
    previewingR: state.campaigns.previewingR,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArchivedCampaignsAndEditions: data => {
      dispatch(getArchivedCampaignsAndEditions(data));
    },
    getArchivedEditions: data => {
      dispatch(getArchivedEditions(data));
    },
    restoreCampaignR: (campaignId, option) => {
      dispatch(restoreCampaignR(campaignId, option));
    },
    deleteArchivedCampaignR: campaignId => {
      dispatch(deleteArchivedCampaignR(campaignId));
    },
    getPDFR: (data, datab, messages) => {
      dispatch(getPDFR(data, datab, messages));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Archives)
  )
);
